import DialogConfigType from "@Features/dialog/types/DialogConfig.type";

export const dialogDefaultConfig: DialogConfigType = {
    isFullScreen: true,
    isClosedClickOutside: false,
    onClose: () => {},
}